import { mergeStyles } from '@cian/utils';
import * as React from 'react';
import { CSSTransition } from 'react-transition-group';

import * as style from './Notification.css';
import { INotificationsState, ENotificationStyle } from '../../types/notifications';

export interface INotificationProps {
  notifications: INotificationsState;
  closeNotification(): void;
}

export const Notification: React.FC<INotificationProps> = props => {
  const {
    notifications: { text, style: type },
    closeNotification,
  } = props;

  if (!text) {
    return null;
  }

  return (
    <CSSTransition
      in
      classNames={{
        enter: style['animation-enter'],
        enterActive: style['animation-enter-active'],
        exit: style['animation-leave'],
        exitActive: style['animation-leave-active'],
      }}
      timeout={300}
    >
      <div {...mergeStyles(style['container'], type === ENotificationStyle.Error ? style['container--error'] : null)}>
        <div className={style['wrapper']}>{text}</div>
        <div className={style['close-wrapper']}>
          <button className={style['close']} onClick={closeNotification}>
            {/* eslint-disable-next-line react/forbid-elements */}
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11.9 11.9" width="12" height="12">
              <path
                fill="#fff"
                d="M7.364 5.95l4.243-4.243A.999.999 0 1 0 10.193.293L5.95 4.536 1.707.293A1 1 0 1 0 .293 1.707L4.536 5.95.293 10.193a.999.999 0 1 0 1.414 1.414L5.95 7.364l4.243 4.243a.999.999 0 1 0 1.414-1.414L7.364 5.95z"
              />
            </svg>
          </button>
        </div>
      </div>
    </CSSTransition>
  );
};
